import { z } from 'zod'

const jsonResponseSchema = z.object({}).passthrough()

export const billingAdminTopupWriteReserveResponseSchema = jsonResponseSchema
export const billingAdminTopupWriteSettlementPreflightResponseSchema = jsonResponseSchema
export const billingAdminTopupWriteSettlementProviderReadinessResponseSchema = jsonResponseSchema
export const billingAdminTopupWriteSettlementResponseSchema = jsonResponseSchema

export type BillingAdminTopupWriteReserveResponse = z.infer<typeof billingAdminTopupWriteReserveResponseSchema>
export type BillingAdminTopupWriteSettlementPreflightResponse = z.infer<typeof billingAdminTopupWriteSettlementPreflightResponseSchema>
export type BillingAdminTopupWriteSettlementProviderReadinessResponse = z.infer<typeof billingAdminTopupWriteSettlementProviderReadinessResponseSchema>
export type BillingAdminTopupWriteSettlementResponse = z.infer<typeof billingAdminTopupWriteSettlementResponseSchema>
